<template lang="pug">
v-expand-transition
  div(:key="loading" style="position:relative")
    v-overlay(v-if="loading" :value="loading" absolute)
      v-progress-circular(indeterminate)
    template(v-else)
      v-card.d-flex.mt-2(outlined)
        v-btn.rounded.mr-2(
          @click="$emit('open-create')"
          fab
          tile
          x-small
          color="success"
        )
          v-icon mdi-plus
        p.title.mb-0 {{ addTitle }}

      div(v-for="item in items" :key="item.id")
        v-card(outlined).d-flex.mt-2
          v-btn.rounded.mr-2(
            @click="toggleSelected(item.id)"
            fab
            tile
            x-small
            color="info"
          )
            v-icon {{ selected === item.id ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
          p.title.mb-0.mr-auto {{ item.name }}
          v-btn.rounded(@click="$emit('edit', item)" fab tile x-small text)
            v-icon mdi-pencil
          v-btn.rounded(@click="$emit('delete', item.id)" fab tile x-small color="error")
            v-icon mdi-close
        div.pl-9
          slot(name="children" v-bind="{ item, selected }")
      slot
</template>

<script>
import SelectProject from '@/components/inputs/SelectProject.vue';

export default {
  components: {  SelectProject },
  props:{
    addTitle:{ type:String, required: false, default: 'Новый элемент' },
    items:{ type:Array, required: true, default: () => [] },
    loading:{ type:Boolean, required: false, default: false },
  },
  data() {
    return {
      selected: null,
    };
  },
  methods: {
    toggleSelected(id) {
      this.selected =  this.selected === id ? null : id;
    },
  },
};
</script>
